import { Routes } from '@angular/router';
import { growthBookGuard } from './guards/growth-book.guard';
import { loggedInRedirectGuard } from './guards/logged-in-redirect.guard';
import { notFoundGuard } from './guards/not-found.guard';
import { promoSaveGuard } from './guards/promo-save.guard';
import { trackingIdGuard } from './guards/tracking-id.guard';
import { websiteMetaResolver } from './resolves/website-meta.resolver';

const allRoutes: Routes = [
  {
    path: '',
    redirectTo: '/a',
    pathMatch: 'full',
  },
  {
    path: 'a',
    loadChildren: () => import('./account/routes').then(m => m.routes),
    resolve: {
      meta: websiteMetaResolver,
    },
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/routes').then(m => m.routes),
    resolve: {
      meta: websiteMetaResolver,
    },
  },
  {
    path: '**',
    canActivate: [notFoundGuard],
    loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
    resolve: {
      meta: websiteMetaResolver,
    },
  },
];

export const pwaAppRoutes: Routes = [
  {
    path: '',
    canActivate: [loggedInRedirectGuard, trackingIdGuard, promoSaveGuard, growthBookGuard],
    children: allRoutes,
  },
];
